import { render, staticRenderFns } from "./PartialBlockVideo.vue?vue&type=template&id=126c4ce3&scoped=true"
import script from "./PartialBlockVideo.vue?vue&type=script&lang=js"
export * from "./PartialBlockVideo.vue?vue&type=script&lang=js"
import style0 from "./PartialBlockVideo.vue?vue&type=style&index=0&id=126c4ce3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c4ce3",
  null
  
)

export default component.exports